import { gql } from '@apollo/client';

import { lessonFragment } from '../fragments';

export default gql`
  mutation CreateLesson(
    $courseId: String!
    $groupId: String!
    $input: CreateLessonInput
  ) {
    lesson(courseId: $courseId, groupId: $groupId, input: $input)
      @rest(
        type: "Lesson"
        path: "courses/{args.courseId}/groups/{args.groupId}/lessons"
        method: "POST"
      ) {
      ...Lesson
    }
  }
  ${lessonFragment}
`;
